import React from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { INTEGRATIONS_CONFIG } from "../../../config/integrations.config"

export const EraUploadTableHeaderComponent: React.FunctionComponent = () => {
    return (
        <div className="table-row w-full">
            <div className="flex items-center gap-[16px] bg-brand-white px-[16px]">
                {Object.entries(
                    INTEGRATIONS_CONFIG.eraUpload.ruleDisplayTableColumnMapping,
                ).map(([key, columnConfig]) => (
                    <PrimaryText
                        key={key}
                        typography="h6"
                        className={`
                            opacity-75 flex-shrink-0 py-[8px]
                            ${columnConfig.tableWidthClassName || "w-[150px]"}
                        `}
                    >
                        {columnConfig.header}
                    </PrimaryText>
                ))}
            </div>
        </div>
    )
}
